import { useTranslation } from "react-i18next";
import { Building2, Car, Home, Mail, Phone, Plus, Wallet } from "lucide-react";
import { InfoRow } from "./InfoRow";

export const EmployeeInfoCard = ({ profile, branchNames }) => {
  const { t } = useTranslation();
  const p = profile || {};
  const money = (v) => (v || v === 0 ? Number(v).toLocaleString() : null);
  return (
    <div data-testid="detail-info">
      <h3 className="mb-1 text-sm font-bold text-foreground/80">{t("detail.info")}</h3>
      <div className="divide-y divide-border/40">
        <InfoRow icon={Mail} label={t("auth.email")} value={p.email} chevron />
        <InfoRow icon={Phone} label={t("detail.phone")} value={p.phone} chevron />
        <InfoRow icon={Building2} label={t("employees.branches")} chips={branchNames} chevron />
        <InfoRow icon={Wallet} label={t("employees.salary")} value={money(p.basic_salary)} />
        <InfoRow icon={Home} label={t("employees.allowance.housing")} value={money(p.allowances?.housing)} />
        <InfoRow icon={Car} label={t("employees.allowance.transport")} value={money(p.allowances?.transport)} />
        <InfoRow icon={Plus} label={t("employees.allowance.other")} value={money(p.allowances?.other)} />
      </div>
    </div>
  );
};
